var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCursorClick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,5h3a.5.5,0,0,1,0,1h-3a.5.5,0,0,1,0-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0A.5.5,0,0,1,8,.5v3a.5.5,0,1,1-1,0V.5A.5.5,0,0,1,7.5,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17,9.85a.59.59,0,0,1,0-.8L4.91,7.18a.5.5,0,0,1,.74,0,.59.59,0,0,1,0,.8L3.91,9.85A.5.5,0,0,1,3.17,9.85Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91,1.18,5.65,3a.59.59,0,0,1,0,.8.5.5,0,0,1-.74,0L3.17,2a.59.59,0,0,1,0-.8A.5.5,0,0,1,3.91,1.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.86,1.18a.59.59,0,0,1,0,.8L10.12,3.85a.5.5,0,0,1-.74,0,.59.59,0,0,1,0-.8l1.74-1.87A.5.5,0,0,1,11.86,1.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,5h3a.5.5,0,0,1,0,1h-3a.5.5,0,0,1,0-1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13,13.5a.24.24,0,0,0,.27,0l1.89-.81,1.23,3.1a.28.28,0,0,0,.27.18l.12,0L12,15.51a.32.32,0,0,0,.16-.4L10.92,12l1.89-.81A.3.3,0,0,0,13,11a.31.31,0,0,0-.08-.28L7.5,5.06A.28.28,0,0,0,7.19,5,.3.3,0,0,0,7,5.28v8A.32.32,0,0,0,7.13,13.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCursorClick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cursor-click.fe6970f15490c377e7ee188ec55fde28.svg";